import { css } from '@emotion/react';
import sctheme from 'app/styles/sctheme';

const styles = sctheme => css`
  .status-label {
    font-size: 13px;
    text-transform: uppercase;
    font-weight: bold;
  }

  .status-value {
    color: ${sctheme.black};
    font-size: 20px;
    font-weight: bold;
  }

  .invoicing-busy {
    color: ${sctheme.blues.primary};
    font-size: 24px;
    text-align: left;
    margin-top: 0.4rem;
  }

  .filter-results-wrapper {
    flex-wrap: wrap;
    gap: 8px;
  }

  .filter-title {
    text-wrap-mode: nowrap;
    color: ${sctheme.grays.$900};
    font-size: 13px;
    text-transform: uppercase;
    margin-top: 8px;
  }

  .filter {
    padding: 0.5rem 1rem;
    border-radius: 8px;
    background-color: ${sctheme.blues.primaryLight};
    font-size: 14px;
    color: ${sctheme.black};
  }
`;

export default styles(sctheme);
